import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { PublicNewsService } from 'src/app/services/public-news.service';
import { TranslationService } from 'src/app/shared/i18n/translation.service';

@Component({
    selector: 'app-public-news',
    templateUrl: './public-news.component.html',
})
export class PublicNewsComponent implements OnInit {

    models: any[] = [];
    paginatedModels: any[] = [];
    currentPage = 1;
    itemsPerPage = 10;
    totalItems = 0;
    searchTerm = '';
    maxPageButtons = 5;
    isLoading: boolean = false;

    /** referenceId of the active category — null means "all" */
    activeCategoryId: string | null = null;

    constructor(
        private service: PublicNewsService,
        public translationServices: TranslationService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        // Re-fetch whenever ?category= changes without a full navigation
        this.route.queryParamMap.subscribe(params => {
            this.activeCategoryId = params.get('category');
            this.currentPage = 1;
            this.getData();
        });
    }

    getData() {
        this.isLoading = false;

        const lang = this.translationServices.getSelectedLanguage();
        const langId = lang === 'ar' ? 1 : lang === 'en' ? 2 : 3;

        const requestPayload: any = {
            paginator: {
                page: this.currentPage,
                pageSize: this.itemsPerPage,
                total: this.totalItems,
                pageSizes: []
            },
            searchTerm: this.searchTerm,
            langId,
        };

        // Pass category filter when a category is selected
        if (this.activeCategoryId) {
            requestPayload.categoryNewsReferenceId = this.activeCategoryId;
        }

        this.service.getAllPagnation$(requestPayload).subscribe((response: any) => {
            this.models = response.items ?? [];
            this.totalItems = response.total ?? 0;
            this.paginatedModels = this.models;
            this.isLoading = true;
        });
    }

    getHeader_Img(): string | null {
        return localStorage.getItem('News');
    }

    createImgPath = (serverPath: string) => {
        if (serverPath) return `${environment.patchUrl}/${serverPath}`;
    }

    changePage(page: number) {
        this.currentPage = page;
        this.getData();
    }

    isPageActive(page: number): boolean {
        return this.currentPage === page;
    }

    getPageNumbers(): number[] {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        const startPage = Math.max(1, this.currentPage - Math.floor(this.maxPageButtons / 2));
        const endPage = Math.min(startPage + this.maxPageButtons - 1, totalPages);
        const pages: number[] = [];
        for (let i = startPage; i <= endPage; i++) pages.push(i);
        return pages;
    }

    isPreviousDisabled(): boolean { return this.currentPage === 1; }

    isNextDisabled(): boolean {
        return this.currentPage === Math.ceil(this.totalItems / this.itemsPerPage);
    }

    goToPreviousPage() {
        if (this.currentPage > 1) this.changePage(this.currentPage - 1);
    }

    goToNextPage() {
        const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
        if (this.currentPage < totalPages) this.changePage(this.currentPage + 1);
    }
}
